import AlignTextRightIcon from '@atlaskit/icon/core/align-text-right';
import React from 'react';

export const SvgAlignRight = () => (
  <AlignTextRightIcon label="" testId="ads-refreshed-icon" />
);
